import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'circular-chart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg viewBox="0 0 46 46"
         role="progressbar"
         [attr.aria-valuenow]="value"
         aria-valuemin="0"
         aria-valuemax="100">
      <path class="circle-bg"
            [attr.d]="getPath()" />
      <path class="circle"
            *ngIf="value > 0"
            [attr.d]="getPath()"
            [attr.stroke-dasharray]="calculateStrokeDashArray()" />
    </svg>
    <div *ngIf="text" class="progress-text">{{ text }}</div>
  `,
  styles: [`
    :host {
      padding: 0;
      position: relative;
      --font-size: 12px;
    }

    svg {
      width: 100%;
      height: 100%;
    }

    .progress-text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: var(--font-size);
      font-weight: 500;
    }

    .circle-bg {
      fill: none;
      stroke: #F2F2F2;
      stroke-width: 6;
    }

    .circle {
      fill: none;
      stroke: #66D68D;
      stroke-width: 6;
      stroke-linecap: round;
      transition: stroke-dasharray 0.5s ease;
    }
  `]
})
export class CircularChartComponent {
  @Input() value: number = 0;
  @Input() text: string;
  @Input() radius: number = 20;
  @Input() @HostBinding('style.width.px') width: number = 46;
  @Input() @HostBinding('style.height.px') height: number = 46;

  center(): number {
    return this.width / 2;
  }

  getPath(): string {
    const c = this.center();
    return `M ${c} ${c - this.radius}
            a ${this.radius} ${this.radius} 0 0 1 0 ${this.radius * 2}
            a ${this.radius} ${this.radius} 0 0 1 0 -${this.radius * 2}`;
  }

  calculateStrokeDashArray(): string {
    const circumference = 2 * Math.PI * this.radius;
    const dashLength = Math.min((this.value / 100) * circumference, circumference);
    return `${dashLength} ${circumference}`;
  }
}
